// extracted by mini-css-extract-plugin
export default {"outlinedButton":"VZBvdP"};